/**
 * roro-cart-pack — plegar y desplegar el bloque de set del carrito.
 *
 * `snippets/cart-products.liquid` agrupa las líneas que comparten la propiedad
 * `_roro_pack` bajo una cabecera propia. Este archivo hace la única parte que
 * el CSS no puede hacer solo: esconder las líneas del pack al pulsar la
 * cabecera.
 *
 * POR QUÉ HAY ESTADO EN UN Map Y NO EN EL DOM
 *
 * El cajón se re-renderiza ENTERO en cada `cart:update`
 * (`assets/component-cart-items.js` morfea la sección), así que cualquier clase
 * o atributo que ponga este archivo desaparece en el siguiente cambio de
 * cantidad. El estado vive aquí, en memoria, y se vuelve a aplicar después de
 * cada repintado. Por defecto un pack está ABIERTO: llega de añadirlo y lo
 * primero que quiere ver el cliente es qué hay dentro.
 *
 * No usa `<details>` porque las líneas son `<tr>` de una tabla y un `<details>`
 * no puede envolver filas sin romper el `<tbody>`.
 */
(function () {
  'use strict';

  // Dos instancias del snippet en la misma página emiten dos <script src>
  // idénticos y el navegador ejecuta los dos.
  if (window.roroCartPackReady) return;
  window.roroCartPackReady = true;

  // packId -> true si está plegado. Ausente = abierto.
  var collapsed = Object.create(null);

  /* Se comparan los `dataset` en vez de meter el id en un selector de
     atributo: el token es de origen propio, pero un selector construido con
     una cadena siempre es una vía de escape de más y aquí no aporta nada. */
  function apply(packId) {
    var isCollapsed = collapsed[packId] === true;

    document.querySelectorAll('[data-roro-pack-head]').forEach(function (head) {
      if (head.dataset.roroPackHead !== packId) return;
      head.classList.toggle('cart-items__pack-head--collapsed', isCollapsed);
    });

    document.querySelectorAll('[data-roro-pack-toggle]').forEach(function (btn) {
      if (btn.dataset.roroPackToggle !== packId) return;
      btn.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
    });

    document.querySelectorAll('[data-roro-pack]').forEach(function (row) {
      if (row.dataset.roroPack !== packId) return;
      row.hidden = isCollapsed;
    });
  }

  function applyAll() {
    document.querySelectorAll('[data-roro-pack-toggle]').forEach(function (btn) {
      apply(btn.dataset.roroPackToggle);
    });
  }

  // Delegación en el documento: las cabeceras aparecen y desaparecen con cada
  // morph, así que enganchar listeners a cada botón sería enganchar de nuevo en
  // cada repintado.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-roro-pack-toggle]');
    if (!btn) return;

    var packId = btn.dataset.roroPackToggle;
    if (!packId) return;

    event.preventDefault();
    collapsed[packId] = collapsed[packId] !== true;
    apply(packId);
  });

  /**
   * Despues de cada repintado del carrito hay que volver a aplicar lo plegado.
   *
   * Se reintenta varias veces en vez de esperar un `requestAnimationFrame`: el
   * evento `cart:update` llega ANTES de que el morph termine, y el rAF no se
   * ejecuta cuando el documento no esta pintando —la misma trampa que ya
   * documenta `assets/roro-product-carousel.js`—, asi que con un solo salto de
   * frame el pliegue se perdia en cada cambio de cantidad. `apply()` es
   * idempotente, asi que repetirlo no cuesta nada.
   */
  var RETRIES = [0, 80, 250, 600];

  document.addEventListener('cart:update', function () {
    RETRIES.forEach(function (delay) {
      window.setTimeout(applyAll, delay);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }
})();
